import axios from 'axios';

const headers =  {
    'Accept': 'application/json',
    'Content-Type': 'application/x-www-form-urlencoded'
};

const baseURL = process.env.VUE_APP_API_BASE_URL || 'http://localhost:8001/api';

const client = axios.create({
    baseURL,
    headers
})

// client.defaults.withCredentials = true;

// client.defaults.headers.common['Accept'] = 'application/json';
// client.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
// client.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";

export {
    client
}
